import { createFileRoute } from "@tanstack/react-router"
import { Legal } from "@/content"

export const Route = createFileRoute("/(public)/legal/$slug")({
  component: RouteComponent,
})

function RouteComponent() {
  const { slug } = Route.useParams()

  return <Legal slug={slug} />
}
